export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputIPAddress",
            data: {
                onChange,
                attrs: {
                    value: settings[name],
                }
            }
        }
    ]
}